import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "leaflet/dist/leaflet.css";
import "./index.css";
import DataProvider from "./contexts/DataProvider.tsx";
import AppProvider from "./contexts/AppProvider.tsx";
import StripeProvider from "./components/payment/StripeProvider.tsx";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { prospoTheme } from "./theme/theme.ts";
import { NotificationProvider } from "./contexts/NotificationProvider.tsx";
import { UploadProvider } from "./contexts/UploadContext.tsx";

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <HelmetProvider>
    <ThemeProvider theme={prospoTheme}>
      <CssBaseline />
      <DataProvider>
        <AppProvider>
          <NotificationProvider>
            <UploadProvider>
              <StripeProvider>
                <App />
              </StripeProvider>
            </UploadProvider>
          </NotificationProvider>
        </AppProvider>
      </DataProvider>
    </ThemeProvider>
  </HelmetProvider>,
  // </React.StrictMode>
);
